let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bPJN2")).then(() => parcelRequire('jx0tK'));